<template>
  <div class="flex h-full w-full flex-col items-center overflow-x-hidden">
    <Html :lang="head.htmlAttrs?.lang" :dir="head.htmlAttrs?.dir">
      <Head>
        <Title>{{ title }}</Title>
        <template v-for="link in head.link" :key="link.id">
          <Link
            :id="link.id"
            :rel="link.rel"
            :href="link.href"
            :hreflang="link.hreflang"
          />
        </template>
        <template v-for="meta in head.meta" :key="meta.id">
          <Meta
            :id="meta.id"
            :property="meta.property"
            :content="meta.content"
          />
        </template>
      </Head>
      <Body>
        <TheHeader class="w-full" />

        <main class="h-full w-full">
          <slot />
        </main>

        <TheFooter class="w-full" />
      </Body>
    </Html>
  </div>
</template>

<script setup lang="ts">
const route = useRoute();
const { t } = useI18n();
const head = useLocaleHead();
const title = computed(() =>
  t('layout.title', {
    title: t((route.meta?.title as string) ?? 'layout.TBD'),
  }),
);
</script>
